import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import type { ConfigProps } from '../pages/messages/utils';
import { useAuth } from './useAuth';

interface TopicsProps {
	name: string;
	value: string;
	additional_fields: ConfigProps;
}

function useGetTopics() {
	const { session } = useAuth();

	const getTopics = async (): Promise<TopicsProps[]> => {
		const response = await axios.get(
			`${import.meta.env.VITE_API_HOST}/api/v1/threads/topics`,
			{
				headers: { Authorization: session?.tokenized },
			},
		);

		return response.data;
	};

	return useQuery({
		queryKey: ['topics'],
		queryFn: () => getTopics(),
	});
}

export default useGetTopics;
